import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { stringFormatter } from 'helpers/i18n';
import mapStateToProps from './mapStateToProps';

import cn from './styles.local.less';

class LinkBoxes extends PureComponent {
  static propTypes = {
    cities: PropTypes.array,
    cityMakesByCity: PropTypes.array,
    cityMakesByMake: PropTypes.array,
    cityModelsByCityMake: PropTypes.array,
    cityModelsByCityModel: PropTypes.array,
    cityModelsByModel: PropTypes.array,
    cityModelsBySubtype: PropTypes.array,
    makes: PropTypes.array,
    models: PropTypes.array,
    subtypes: PropTypes.array,
    titles: PropTypes.object.isRequired,
  };

  isVisible() {
    const {
      cities,
      cityMakesByCity,
      cityMakesByMake,
      cityModelsByCityMake,
      cityModelsByCityModel,
      cityModelsByModel,
      cityModelsBySubtype,
      makes,
      models,
      subtypes,
    } = this.props;

    return (
      cities.length ||
      cityMakesByCity.length ||
      cityMakesByMake.length ||
      cityModelsByCityMake.length ||
      cityModelsByCityModel.length ||
      cityModelsByModel.length ||
      cityModelsBySubtype.length ||
      makes.length ||
      models.length ||
      subtypes.length
    );
  }

  renderLinkBox = (links) => {
    return (
      <ul className={cn.linkBoxContainer}>
        {links.map(({ link, title }, index) => (
          <li className={cn.listItem} key={`${link}_${index}`}>
            <Link to={link} className={cn.link}>
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const {
      makes,
      models,
      subtypes,
      cities,
      cityMakesByCity,
      cityMakesByMake,
      cityModelsByCityMake,
      cityModelsByCityModel,
      cityModelsByModel,
      cityModelsBySubtype,
      titles,
    } = this.props;

    return this.isVisible() ? (
      <div className={cn.root}>
        {cityModelsByModel.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityModelsByModel'))(titles)}
            </h3>
            {this.renderLinkBox(cityModelsByModel)}
          </Fragment>
        ) : null}

        {cityModelsBySubtype.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityModelsBySubtype'))(titles)}
            </h3>
            {this.renderLinkBox(cityModelsBySubtype)}
          </Fragment>
        ) : null}

        {cityModelsByCityMake.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityModelsByCityMake'))(
                titles,
              )}
            </h3>
            {this.renderLinkBox(cityModelsByCityMake)}
          </Fragment>
        ) : null}

        {cityModelsByCityModel.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityModelsByCityModel'))(
                titles,
              )}
            </h3>
            {this.renderLinkBox(cityModelsByCityModel)}
          </Fragment>
        ) : null}

        {cityMakesByCity.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityMakesByCity'))(titles)}
            </h3>
            {this.renderLinkBox(cityMakesByCity)}
          </Fragment>
        ) : null}

        {cityMakesByMake.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.cityMakesByMake'))(titles)}
            </h3>
            {this.renderLinkBox(cityMakesByMake)}
          </Fragment>
        ) : null}

        {cities.length ? (
          <Fragment>
            <h3 className={cn.title}>{__('linkbox.title.cities')}</h3>
            {this.renderLinkBox(cities)}
          </Fragment>
        ) : null}

        {subtypes.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.subType'))(titles)}
            </h3>
            {this.renderLinkBox(subtypes)}
          </Fragment>
        ) : null}

        {models.length ? (
          <Fragment>
            <h3 className={cn.title}>
              {stringFormatter(__('linkbox.title.model'))(titles)}
            </h3>
            {this.renderLinkBox(models)}
          </Fragment>
        ) : null}

        {makes.length ? (
          <Fragment>
            <h3 className={cn.title}>{__('linkbox.title.make')}</h3>
            {this.renderLinkBox(makes)}
          </Fragment>
        ) : null}
      </div>
    ) : null;
  }
}

export default connect(mapStateToProps)(LinkBoxes);
